import React, { useEffect, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';

const SetWidthModal = ({ show, onHide, column, currentWidth, onSave }) => {
  const [width, setWidth] = useState(currentWidth);

  useEffect(() => {
    setWidth(currentWidth);
  }, [currentWidth, show]);

  const handleSave = () => {
    if (!isNaN(width) && width >= 40 && width <= 800) {
      onSave(Math.max(40, Math.min(800, width)));
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Set Column Width — {column}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Width in pixels for <strong>{column}</strong></Form.Label>
          <Form.Control
            type="number"
            min="40"
            max="800"
            value={width}
            onChange={(e) => setWidth(parseInt(e.target.value, 10) || 40)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="removeProfile" onClick={onHide}>Cancel</button>
        <button type="button" className="updateProfile" onClick={handleSave}>Set Width</button>
      </Modal.Footer>
    </Modal>
  );
};

const DatasetViewerModals = ({
  showModal,
  modalContent,
  setShowModal,
  showColFilterModal,
  setShowColFilterModal,
  colFilterTarget,
  columns,
  colFilterOp,
  setColFilterOp,
  colFilterVal,
  setColFilterVal,
  colFilterVal2,
  setColFilterVal2,
  handleColFilterApply,
  showSetWidthModal,
  setShowSetWidthModal,
  widthTarget,
  getWidth,
  setColumnWidth
}) => (
  <>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      {modalContent && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{modalContent.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
              {modalContent.body}
            </div>
          </Modal.Body>
          <Modal.Footer className="p-2">
            <button type="button" className="removeProfile" onClick={() => setShowModal(false)}>
              {modalContent.onPrimary ? 'Cancel' : 'Close'}
            </button>
            {modalContent.onPrimary && (
              <button type="button" className="updateProfile" onClick={modalContent.onPrimary}>
                {modalContent.primaryLabel || 'OK'}
              </button>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>

    <Modal show={showColFilterModal} onHide={() => setShowColFilterModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Column — {colFilterTarget !== null ? columns[colFilterTarget] : ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-muted small mb-2">
          Column <b>{colFilterTarget !== null ? columns[colFilterTarget] : ''}</b> · type: {colFilterTarget !== null ? (columns[colFilterTarget] ? columns[colFilterTarget] : '') : ''}
        </div>
        <Form.Group className="mb-2">
          <Form.Label>Condition</Form.Label>
          <Form.Select
            value={colFilterOp}
            onChange={(e) => {
              setColFilterOp(e.target.value);
              if (e.target.value === 'blank' || e.target.value === 'nonblank') {
                setColFilterVal('');
                setColFilterVal2('');
              }
            }}
          >
            {colFilterTarget !== null && (() => {
              const ty = columns[colFilterTarget] ? (columns[colFilterTarget].rawType || 'character') : 'character';
              const ops = ty === 'numeric' ?
                [['eq', 'Equals'], ['ne', 'Not equals'], ['gt', 'Greater than'], ['lt', 'Less than'], ['between', 'Between'], ['blank', 'Is blank'], ['nonblank', 'Is not blank']] :
                ty === 'date' ?
                  [['before', 'Before'], ['after', 'After'], ['dbetween', 'Between'], ['eq', 'Equals'], ['blank', 'Is blank'], ['nonblank', 'Is not blank']] :
                  [['contains', 'Contains'], ['eq', 'Equals'], ['ne', 'Not equals'], ['starts', 'Starts with'], ['ends', 'Ends with'], ['blank', 'Is blank'], ['nonblank', 'Is not blank']];
              return ops.map(([val, label]) => (
                <option key={val} value={val}>{label}</option>
              ));
            })()}
          </Form.Select>
        </Form.Group>
        {colFilterOp !== 'blank' && colFilterOp !== 'nonblank' && (
          <Form.Group className="mb-2">
            <Form.Label>Value</Form.Label>
            <Form.Control type="text" value={colFilterVal} onChange={(e) => setColFilterVal(e.target.value)} />
          </Form.Group>
        )}
        {(colFilterOp === 'between' || colFilterOp === 'dbetween') && (
          <Form.Group className="mb-2">
            <Form.Label>And</Form.Label>
            <Form.Control type="text" value={colFilterVal2} onChange={(e) => setColFilterVal2(e.target.value)} />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="removeProfile" onClick={() => setShowColFilterModal(false)}>Cancel</button>
        <button type="button" className="updateProfile" onClick={handleColFilterApply}>Apply Filter</button>
      </Modal.Footer>
    </Modal>

    <SetWidthModal
      show={showSetWidthModal}
      onHide={() => setShowSetWidthModal(false)}
      column={widthTarget || ''}
      currentWidth={widthTarget ? getWidth(widthTarget) : 150}
      onSave={(w) => {
        if (widthTarget) {
          setColumnWidth(widthTarget, w);
        }
      }}
    />
  </>
);

export default DatasetViewerModals;
